import React, {useContext, useState} from "react";
import {useNavigate} from "react-router-dom"

import {GroupContext} from "src/pages/context/Group.context";
import {useTranslation} from "react-i18next";
import {LoadingOutlined} from "@ant-design/icons";
import {Button, Spin} from "antd";

import cardStyles from "./GroupCardFile.module.scss";
import {getUrlHttp} from "src/service/util.service";
import {pathRoutes} from "src/props/util.props";
import {tabName} from "../properies.file";
import {FileContext} from "../File.context";
import earth_grid_symbol from "src/assets/png/earth_grid_symbol.png";

interface GroupCardProps {
  image: string;
  member: number;
  favorite: boolean;
  groupName: string;
  joined: boolean;
  groupID: string;
  group: string;
}

const GroupCardFile = React.forwardRef((props: any, ref: any) => {
  const { t } = useTranslation();
  const groupCtx: any = useContext(GroupContext);
  const fileContext: any = useContext(FileContext);
  let text = t("Files");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [buttonText, setButtonText] = useState(text);
  const [isClickedJoin, setIsClickedJoin] = useState(false);
  const [isJoined, setIsJoined] = useState(props.joined);
  // const buttonText = props.joined ? "Chat" : "join";

  const handleClick = async () => {
    console.log("click group");
    fileContext.setClickFromGroupTab(true);
    sessionStorage.setItem("group-tab-groupId",props.groupID);
    fileContext.setFileFolders([]);
    // fileContext.setParentFolderId("");
    // fileContext.setGroupId("");
    fileContext.setTab(tabName.myFile);
    // navigate(pathRoutes.File + "?id=" + props.groupID);

    if (props.group?.mainType === "community" || 
    props.group?.mainType === "messaging" ||
    props.group?.mainType === "organization") {
      // setTimeout(() => {
        navigate(`${pathRoutes.groupCommunity}/${props.groupID}/file`, {state:{ groupProps: props }});
      // }, 0);
    } else {
      
        navigate(pathRoutes.File + "/id/" + props.groupID );
      
    }
  };

  const checkCommunity = () => {
    if (props.group?.mainType === "community") {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div
      ref={ref}
      className={cardStyles.card}
      style={{
        backgroundImage: `url(${getUrlHttp(props.image)})`,
        backgroundSize: "cover",
      }}
    >
      {checkCommunity() && (
        <div className={cardStyles.boxGroup}>
          <img src={earth_grid_symbol} width={17} height={17}></img>
        </div>
      )}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
        }}
      >
        {/* {props.favorite ? (
          <HeartFilled className={cardStyles.heartIcon} />
        ) : (
          <HeartOutlined className={cardStyles.heartIcon} />
        )} */}
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div className={cardStyles.headCardDetail}>{props.groupName}</div>
        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "space-between",
          }}
        >
          <div
            className={cardStyles.cardDetail}
          >{`(${props.member} people)`}</div>
          <Button
            className={
              props.requested || isClickedJoin
                ? cardStyles.requestedButton
                : cardStyles.chatButton
            }
            onClick={handleClick}
          >
            {!isLoading ? (
              t(buttonText)
            ) : (
              <Spin
                indicator={
                  <LoadingOutlined
                    style={{ fontSize: "20px", color: "#0F4C82" }}
                  />
                }
              />
            )}
          </Button>
        </div>
      </div>
    </div>
  );
});

export default GroupCardFile;
